/**
 * Maps language codes (e.g. from tweet lang) to country codes for flag icons.
 * Uses ISO 3166-1 alpha-2 for flag-icons (`fi fi-xx`).
 * Full ISO 639-1 + common ISO 639-2 mappings + BCP47 regions live in `./languageFlagMap`.
 */
import { resolveFlagCountryCode } from './languageFlagMap';

export * from './languageFlagMap';

export function getLangCountryCode(lang: string | null | undefined): string {
  if (lang == null || lang === '') return 'un';
  return resolveFlagCountryCode(lang);
}
